<template>
  <div>
    <div v-if="googleError" class="text-white text-red bg-red-1 q-pa-xs q-mb-md text-center">
      {{ googleError }}
    </div>
    <div id="buttonDiv" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { checkToken } from '@nitra/components/njs/token.js'
import tf from '@nitra/tf/webpack'

const googleError = ref('')

const props = defineProps({
  id: { type: String, default: null, required: true }
})

// событие когда пользователь авторизован
const emit = defineEmits(['input'])

const tr = {
  'Помилка Google авторизації': 'Ошибка авторизации Google',
  'Користувачу не дозволено вхід': 'Пользователю не разрешен входит'
}
const t = tf.bind({ tr })

const local = process.env.VITE_T ? 'ru_RU' : 'uk-UA'

// Завантажуємо скрипт Google асинхронно
const scriptTag = document.createElement('script')
scriptTag.src = 'https://accounts.google.com/gsi/client'
scriptTag.async = true
scriptTag.defer = true
// Та коли він завантажився ініціалізуємо його
scriptTag.addEventListener('load', () => {
  window.google.accounts.id.initialize({
    client_id: props.id,
    callback: handleCredentialResponse
  })
  // рендеримо кнопку з атрибутами
  window.google.accounts.id.renderButton(document.querySelector('#buttonDiv'), {
    theme: 'filled_white',
    size: 'large',
    text: 'signin_with',
    width: '270',
    locale: local
  })
})
document.head.append(scriptTag)

// Коли відповідь від кнопки прийшла
/**
 *
 * @param credentialResponse
 */
async function handleCredentialResponse(credentialResponse) {
  const credential = credentialResponse.credential
  googleError.value = ''

  if (!credentialResponse.clientId || !credential) {
    googleError.value = t`Помилка Google авторизації`
    return
  }

  const headers = {
    'Content-Type': 'application/json'
  }
  if (process.env.APP) {
    headers['app'] = process.env.APP
  }

  try {
    const respFromRun = await fetch('/auth/google', {
      method: 'POST',
      headers,
      body: JSON.stringify({
        credential
      })
    })

    const res = await respFromRun.json()

    if (res?.token) {
      // Перенаправляємо користувача на home, якщо йому дозволено тільки home
      if (checkToken(res.token)) {
        emit('input', true)
      } else {
        googleError.value = t`Користувачу не дозволено вхід`
      }
    } else {
      googleError.value = t`Помилка Google авторизації`
    }
  } catch (error) {
    googleError.value = error
  }
}
</script>
